import MembersTermsIcon1 from "../../assets/images/membersTermsImg1.svg";
import MembersTermsIcon2 from "../../assets/images/membersTermsImg2.svg";
import MembersTermsIcon3 from "../../assets/images/membersTermsImg3.svg";

export const nominationFormData = [
  {
    id: 1,
    img: MembersTermsIcon1,
    heading: "Mentor",

    featureList: [
      {
        title: "Professional Commitment",
        desc: "Uphold academic integrity, ethical mentorship standards, and professional conduct in all engagements.",
      },
      {
        title: "Time Allocation",
        desc: "Dedicate structured time for mentorship activities and academic guidance as per program expectations.",
      },
      {
        title: "Quality & Confidentiality",
        desc: "Provide constructive feedback while maintaining confidentiality of research discussions.",
      },
      {
        title: "Compliance & Conduct",
        desc: "Adhere to institutional employment rules, platform guidelines (where applicable), and IMPARC’s Code of Conduct.",
      },
    ],
  },
  {
    img: MembersTermsIcon2,
    heading: "Research Associate",
    id: 2,
    featureList: [
      {
        title: "Publishing Benefits",
        desc: "Eligible for free or discounted journal and book publishing as per membership structure (subject to editorial approval).",
      },
      {
        title: "Research Ethics",
        desc: "Ensure originality, ethical research practices, and proper citation standards.",
      },
      {
        title: "Progress & Communication",
        desc: "Maintain regular communication and timely submission of manuscripts or revisions.",
      },
      {
        title: "Benefit Usage Terms",
        desc: "Discounts are non-transferable and valid within the defined membership period.",
      },
    ],
  },
  {
    img: MembersTermsIcon3,
    heading: "Knowledge Partner",
    id: 3,
    featureList: [
      {
        title: "Active Participation",
        desc: "Encourage faculty and researchers to actively engage in IMPARC programs and mentorship initiatives.",
      },
      {
        title: "Research & Ethical Standards",
        desc: "Promote institutional compliance with academic integrity and ethical research policies.",
      },
      {
        title: "Coordination & Reporting",
        desc: "Facilitate structured communication, participation tracking, and collaborative engagement.",
      },
      {
        title: "Representation & Attribution",
        desc: "Ensure accurate institutional acknowledgment in publications, events, and recognition platforms.",
      },
    ],
  },
];
